import { useSelector } from "react-redux";
import { useQuery } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";

export const useHealthMailContactsList = () => {
  const tenant =
    useSelector((state) => state.auth.user?.tenant) ||
    localStorage.getItem("kinesin-tenant");

  const fetchHealthMailContactsList = async () => {
    const axiosInstance = createAxiosInstance();
    const response = await axiosInstance.get(`${tenant}/healthmailcontacts`);

    return response.data;
  };

  return useQuery({
    queryKey: ["healthMailContactsList", tenant],
    queryFn: fetchHealthMailContactsList,
    enabled: !!tenant,
  });
};

export default useHealthMailContactsList;
